/*
 * Key Codes (events)
 */

export default {
  SPACE: 32,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PAGEUP: 33,
  PAGEDOWN: 34,
  HOME: 36,
  END: 35
};


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/utils/key-codes.js
// module id = 564
// module chunks = 0